import el_fn from './layerSymbols/el_fn.png';
import branch_break from './layerSymbols/branch_break.png';
import completed_dozer_line from './layerSymbols/completed_dozer_line.png';
import completed_fuel_break from './layerSymbols/completed_fuel_break.png';
import completed_hand_line from './layerSymbols/completed_hand_line.png';
import completed_plow_line from './layerSymbols/completed_plow_line.png';
import contained_line from './layerSymbols/contained_line.png';
import division_break from './layerSymbols/division_break.png';
import el_phl from './layerSymbols/el_phl.png';
import el_pdl from './layerSymbols/el_pdl.png';
import el_ppl from './layerSymbols/el_ppl.png';
import fe_active from './layerSymbols/fe_active.png';
import fe_inactive from './layerSymbols/fe_inactive.png';
import fe_manual from './layerSymbols/fe_manual.png';
import fe_unk from './layerSymbols/fe_unk.png';
import fire_contained from './layerSymbols/fire_contained.png';
import fire_demobed from './layerSymbols/fire_demobed.png';
import fire_dispatched from './layerSymbols/fire_dispatched.png';
import fire_edge from './layerSymbols/fire_edge.png';
import fire_not_dispatched from './layerSymbols/fire_not_dispatched.png';
import fire_origin from './layerSymbols/fire_origin.png';
import fire_station from './layerSymbols/fire_station.png';
import hot_spot from './layerSymbols/hot_spot.png';
import IC_post from './layerSymbols/IC_post.png';
import if_eir_ec from './layerSymbols/if_eir_ec.png';
import if_eir_en from './layerSymbols/if_eir_en.png';
import if_eir_es from './layerSymbols/if_eir_es.png';
import if_eir_ic from './layerSymbols/if_eir_ic.png';
import if_eir_mn from './layerSymbols/if_eir_mn.png';
import if_eir_oh from './layerSymbols/if_eir_oh.png';
import if_eir_ts from './layerSymbols/if_eir_ts.png';
import if_ez_eo from './layerSymbols/if_ez_eo.png';
import if_ez_eol from './layerSymbols/if_ez_eol.png';
import if_ez_ew from './layerSymbols/if_ez_ew.png';
import if_ez_hc from './layerSymbols/if_ez_hc.png';
import if_ez_roc from './layerSymbols/if_ez_roc.png';
import if_ez_sc from './layerSymbols/if_ez_sc.png';
import if_ez_sip from './layerSymbols/if_ez_sip.png';
import if_fp from './layerSymbols/if_fp.png';
import if_rc_fc from './layerSymbols/if_rc_fc.png';
import if_rc_la from './layerSymbols/if_rc_la.png';
import if_rc_tc from './layerSymbols/if_rc_tc.png';
import ir_isolated from './layerSymbols/ir_isolated.png';
import monitored from './layerSymbols/monitored.png';
import noteworthy from './layerSymbols/noteworthy.png';
import pif_agri_enrolled from './layerSymbols/pif_agri_enrolled.png';
import pif_agri_not_enrolled from './layerSymbols/pif_agri_not_enrolled.png';
import pif_comm_enrolled from './layerSymbols/pif_comm_enrolled.png';
import pif_comm_not_enrolled from './layerSymbols/pif_comm_not_enrolled.png';
import pif_res_enrolled from './layerSymbols/pif_res_enrolled.png';
import pif_res_not_enrolled from './layerSymbols/pif_res_not_enrolled.png';
import pif_mgu from './layerSymbols/pif_mgu.png';
import planned_burnout from './layerSymbols/planned_burnout.png';
import planned_dozer_line from './layerSymbols/planned_dozer_line.png';
import planned_fuel_break from './layerSymbols/planned_fuel_break.png';
import planned_hand_line from './layerSymbols/planned_hand_line.png';
import planned_plow_line from './layerSymbols/planned_plow_line.png';
import possible_ir_heat from './layerSymbols/possible_ir_heat.png';
import safety_zone from './layerSymbols/safety_zone.png';
import water_source from './layerSymbols/water_source.png';
import wf_fb05 from './layerSymbols/wf_fb05.png';
import wf_fb1 from './layerSymbols/wf_fb1.png';
import wf_fb3 from './layerSymbols/wf_fb3.png';
import wf_fbo from './layerSymbols/wf_fbo.png';
import wf_fp from './layerSymbols/wf_fp.png';
import wf_tp from './layerSymbols/wf_tp.png';
import zone_break from './layerSymbols/zone_break.png';

import ActiveFireEngine from './mapSymbols/ActiveFireEngine.png';
import DemobilizedFires from './mapSymbols/DemobilizedFires.png';
import DispatchedFires from './mapSymbols/DispatchedFires.png';
import InactiveFireEngine from './mapSymbols/InactiveFireEngine.png';
import IntterraFireIcon from './mapSymbols/IntterraFireIcon.png';
import MonitoredFires from './mapSymbols/MonitoredFires.svg';
import NonDispatchedFires from './mapSymbols/Non-DispatchedFires.png';
import NoteworthyFires from './mapSymbols/NoteworthyFires.svg';
import WDSFireIcon from './mapSymbols/WDSFireIcon.png';

import FirePerimeter from './legendSymbols/fire-perimeter.svg';
import ThreatPerimeter from './legendSymbols/threat-perimeter.svg';
import HalfMileBuffer from './legendSymbols/half-mile-buffer.svg';
import OneMileBuffer from './legendSymbols/one-mile-buffer.svg';
import ThreeMileBuffer from './legendSymbols/three-mile-buffer.svg';
import AlertDistance from './legendSymbols/alert-distance.svg';
import PreviousFires from './legendSymbols/previous-fires.png';
import ResEnrolled from './legendSymbols/res-enrolled.png';
import ResNotEnrolled from './legendSymbols/res-not-enrolled.png';
import ResOther from './legendSymbols/res-other.png';

import CommEnrolled from './legendSymbols/comm-enrolled.png';
import CommNotEnrolled from './legendSymbols/comm-not-enrolled.png';
import CommOther from './legendSymbols/comm-other.png';

import AgriEnrolled from './legendSymbols/agri-enrolled.png';
import AgriNotEnrolled from './legendSymbols/agri-not-enrolled.png';
import AgriOther from './legendSymbols/agri-other.png';

import MguEnrolled from './legendSymbols/mgu-enrolled.png'

import CritBurn from './legendSymbols/crit-burn.svg';
import CritHotDry from './legendSymbols/crit-hot-dry.svg';
import CritLowHumidity from './legendSymbols/crit-low-humidity.svg';
import DryWindy from './legendSymbols/dry-windy.svg';
import HotDryUnstable from './legendSymbols/hot-dry-unstable.svg';
import Lightning from './legendSymbols/lightning.svg';
import LittleRisk from './legendSymbols/little-risk.svg';
import LowRisk from './legendSymbols/low-risk.svg';
import ModerateRisk from './legendSymbols/moderate-risk.svg';
import NoData from './legendSymbols/no-data.svg';
import Recreation  from './legendSymbols/recreation.svg';

import ResEnrolledLegend from './legendSymbols/res-enrolled-icon.svg';
import ResNotEnrolledLegend from './legendSymbols/res-not-enrolled-icon.svg';
import ResOtherLegend from './legendSymbols/res-other-icon.svg';

import CommEnrolledLegend from './legendSymbols/comm-enrolled-icon.svg';
import CommNotEnrolledLegend from './legendSymbols/comm-not-enrolled-icon.svg';
import CommOtherLegend from './legendSymbols/comm-other-icon.svg';

import AgriEnrolledLegend from './legendSymbols/agri-enrolled-icon.svg';
import AgriNotEnrolledLegend from './legendSymbols/agri-not-enrolled-icon.svg';
import AgriOtherLegend from './legendSymbols/agri-other-icon.svg';

import MguEnrolledLegend from './legendSymbols/mgu-enrolled-icon.svg'



export {
    el_fn,
    branch_break,
    completed_dozer_line,
    completed_fuel_break,
    completed_hand_line,
    completed_plow_line,
    contained_line,
    division_break,
    el_phl,
    el_pdl,
    el_ppl,
    fe_active,
    fe_inactive,
    fe_manual,
    fe_unk,
    fire_contained,
    fire_demobed,
    fire_dispatched,
    fire_edge,
    fire_not_dispatched,
    fire_origin,
    fire_station,
    hot_spot,
    IC_post,
    if_eir_ec,
    if_eir_en,
    if_eir_es,
    if_eir_ic,
    if_eir_mn,
    if_eir_oh,
    if_eir_ts,
    if_ez_eo,
    if_ez_eol,
    if_ez_ew,
    if_ez_hc,
    if_ez_roc,
    if_ez_sc,
    if_ez_sip,
    if_fp,
    if_rc_fc,
    if_rc_la,
    if_rc_tc,
    ir_isolated,
    monitored,
    noteworthy,
    pif_comm_enrolled,
    pif_comm_not_enrolled,
    pif_agri_enrolled,
    pif_agri_not_enrolled,
    pif_res_enrolled,
    pif_res_not_enrolled,
    pif_mgu,
    planned_burnout,
    planned_dozer_line,
    planned_fuel_break,
    planned_hand_line,
    planned_plow_line,
    possible_ir_heat,
    safety_zone,
    water_source,
    wf_fb05,
    wf_fb1,
    wf_fb3,
    wf_fbo,
    wf_fp,
    wf_tp,
    zone_break,

    ActiveFireEngine,
    DemobilizedFires,
    DispatchedFires,
    InactiveFireEngine,
    IntterraFireIcon,
    MonitoredFires,
    NonDispatchedFires,
    NoteworthyFires,
    WDSFireIcon,

    OneMileBuffer,
    ThreeMileBuffer,
    AlertDistance,
    HalfMileBuffer,
    FirePerimeter,
    PreviousFires,
    ResEnrolled,
    ResNotEnrolled,
    ThreatPerimeter,
    ResOther,
    CommEnrolled,
    CommNotEnrolled,
    CommOther,
    AgriEnrolled,
    AgriNotEnrolled,
    AgriOther,
    MguEnrolled,
    CritBurn,
    CritHotDry,
    CritLowHumidity,
    DryWindy,
    HotDryUnstable,
    Lightning,
    LittleRisk,
    LowRisk,
    ModerateRisk,
    NoData,
    Recreation,
    ResEnrolledLegend,
    ResNotEnrolledLegend,
    ResOtherLegend,
    CommEnrolledLegend,
    CommNotEnrolledLegend,
    CommOtherLegend,
    AgriEnrolledLegend,
    AgriNotEnrolledLegend,
    AgriOtherLegend,
    MguEnrolledLegend
}